/**
 * @GENERATED from Figma node 3638:51940
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const AuditionBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#3DCC5E"
      d="m6.793 8.37.126-.705.127.705 1.774 5.07H5.073zm3.747 9.975h2.408L8.15 5.438H5.688L1 18.345h2.426l.977-2.896h5.123zM21.009 18.345H23V7.936h-2.39v5.413c0 1.846-.796 3.131-2.37 3.131-1.612 0-2.119-1.122-2.119-2.751V7.936H13.75v6.444c0 2.589 1.194 4.182 3.674 4.182 1.702 0 2.825-.85 3.367-2.208z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(AuditionBright);
export { ForwardRef as AuditionBright };
